'use strict';
const angular = require('angular');
const {extend, isDefined, isObject, isString, noop} = angular;

const simpleTemplate = require('./simple-selector.html');

module.exports = [
  ModalService];

function ModalService() {
  const service = this;
  this.stack = [];
  let keyGen = 0;
  /**
   * @abstract this method must be implemented based on the UI/UX framework selected.
   * @return {Promise}
   * @deprecated
   */
  service.show = noop;
  /**
   * @abstract this method must be implemented based on the UI/UX framework selected.
   * @return {{result: Promise, modal: Promise}}
   */
  service.showModal = noop;
  service.closeLastOpened = closeLastOpened;
  service.register = registerModal;
  service.deregister = deregisterModal;
  service.showBasicSelector = showBasicSelector;

  function showBasicSelector(config) {
    config = extend({}, {
      template: simpleTemplate,
      controller: 'SelectController',
      animation: 'slide-in-right',
    }, config);

    if (!isObject(config.locals) && config.controller === 'SelectController') {
      throw new Error('$modal.showBasicSelector requires {Object} locals containing {Function} loadList');
    } else if (isObject(config.locals)) {
      if (!isString(config.locals.header)) {
        config.locals.header = 'default.selector.header';
      }

      if (!isString(config.locals.toString)) {
        config.locals.toString = 'toString';
      }

      if (!isDefined(config.locals.currentValue)) {
        config.locals.currentValue = null;
      }

      if (!isDefined(config.locals.currentFilter)) {
        config.locals.currentFilter = null;
      }
    }

    return service.show(config);
  }

  function closeLastOpened() {
    if (service.stack.length) {
      service.stack[service.stack.length - 1].hide();
    }
  }

  function registerModal(modal) {
    // console.log('registerng modal', modal);
    Object.defineProperty(modal, '$$id', {value: keyGen++});
    service.stack.push(modal);
    return modal.$$id;
  }

  function deregisterModal(modal) {
    if ('$$id' in modal) {
      let i = service.stack.length;
      while (i--) {
        if (service.stack[i] == modal) {
          service.stack.splice(i, 1);
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/core-components/modals/ModalService.js